@import "highlight.js/styles/stackoverflow-dark.css";

/* Let the MDX pre wrapper own background, padding, and base text color */
pre code.hljs {
  background: transparent;
  color: inherit;
  padding: 0;
}
